// Mocks scenario switch: in the browser console run
//   localStorage.setItem('mockLegacyLocation', '1')   // legacy records
//   localStorage.removeItem('mockLegacyLocation')      // complete records
// Legacy records come without the location fields (only `address`).
export const isLegacyLocationMock = () => {
  try {
    return localStorage.getItem('mockLegacyLocation') === '1'
  } catch {
    return false
  }
}

// Only lat/lng missing (state/city/sector present): setItem('mockLegacyLocation', 'coords')
export const isCoordsOnlyLegacyLocationMock = () => {
  try {
    return localStorage.getItem('mockLegacyLocation') === 'coords'
  } catch {
    return false
  }
}
